export default function () {
    return {
        init() {
            window.addEventListener('resize', () => this.resizeAllGridItems())
            window.addEventListener('load', () => this.resizeAllGridItems())
            
            const onLoadFunc = () => {
                console.log('onload run')
                const imgs = this.$el.getElementsByTagName('img');
                const func = () => {
                    this.resizeAllGridItems();
                }
                for (let i = 0; i < imgs.length; i++) {
                    const img = imgs[i];
                    img.removeEventListener('load', func);
                    img.addEventListener('load', func);
                }
                this.resizeAllGridItems()
            }
            

            const masonryElement = this.$el.querySelector('.masonry');
            masonryElement.addEventListener('mason', () =>  {
                // console.log('mason trigger')
                this.resizeAllGridItems();
                onLoadFunc();
            })

            masonryElement.addEventListener('update-buttons', () => {
                // console.log('update-buttons trigger');
                this.updateButtonProxy();
            })

            this.updateButtonProxy();
            this.resizeAllGridItems();
            

        },
        updateButtonProxy() {
            const loadmoreButton = document.querySelector('#js-load-more-button');
            const proxyButton = this.$refs.loadmore;
            if (!loadmoreButton) {
                proxyButton.classList.add('hidden');
            } else {
                proxyButton.addEventListener('click', () => {
                    loadmoreButton.dispatchEvent(new Event('click'));
                })
            }
        },
        resizeAllGridItems() {
            const items = document.querySelectorAll('.item');
            for (let i = 0; i < items.length; i++) {
                this.resizeGridItem(items[i]);
            }
        },
        resizeInstance(instance) {
            const item = instance.elements[0];
            this.resizeGridItem(item);
        },
        resizeGridItem(item) {

            const rowHeight = this.getStyleProperty('grid-auto-rows');
            const rowGap = this.getStyleProperty('grid-row-gap');
            const rowSpan = Math.ceil((item.querySelector('.content').getBoundingClientRect().height + rowGap) / (rowHeight + rowGap));
            item.style.gridRowEnd = `span ${rowSpan}`;
        },
        getStyleProperty(name) {
            return parseInt(window.getComputedStyle(this.$el.querySelector('.masonry')).getPropertyValue(name))
        }
    }
}